import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'

import { getCurrencySymbol as _getCurrencySymbol } from '@hapana/shared/utils/string.util'

const getCurrencySymbol = (currency) => (currency ? _getCurrencySymbol(currency) : '$')
import Button from '../../button/button.component'
import {
  BUTTON_SIZE,
  BUTTON_THEME,
  BUTTON_VARIANTS,
} from '../../../../components/shared/button/button.constants'
import Accordion from '../../../../components/shared/accordion/accordion.component'
import { formatDistanceToNowAbbreviated as _formatDistanceToNowAbbreviated } from '@hapana/shared/utils/date.util'

const formatDistanceToNowAbbreviated = (date) => {
  if (!date || isNaN(date.getTime())) {
    return ''
  }
  return _formatDistanceToNowAbbreviated(date)
}

import { styles } from './payments-alert.styles'

const SinglePayment = ({ payment, href, onClick, isOpen, onChange, canRetry, label }) => {
  const { t } = useTranslation(['checkIn'])

  return (
    <Accordion
      key={payment.id}
      contentStyles={styles.accordionContent}
      summaryStyles={{
        ...styles.accordionSummary,
        ...(isOpen && styles.openedSummarySingle),
      }}
      isOpen={isOpen}
      onChange={onChange}
      content={
        canRetry ? (
          <Button
            variant={BUTTON_VARIANTS.TEXT}
            size={BUTTON_SIZE.SMALL}
            theme={BUTTON_THEME.PRIMARY}
            stroke
            href={href}
            onClick={onClick}
          >
            {t('checkIn:retryPayment')}
          </Button>
        ) : null
      }
      groupedRows
      label={
        <>
          {isOpen && (
            <>
              <Box sx={styles.flexRow}>
                <Typography typography="header4" color="gray.64">
                  {label}
                </Typography>
                {payment.datetime && (
                  <>
                    <Typography typography="header4" color="gray.56" sx={styles.spacer}>
                      •
                    </Typography>
                    <Typography typography="header4" color="gray.56">
                      {formatDistanceToNowAbbreviated(new Date(payment.datetime))}
                    </Typography>
                  </>
                )}
              </Box>
              {(payment.price != null || payment.siteName) && (
                <Box sx={styles.flexRow}>
                  <Typography typography="medium" color="gray.64">
                    {[
                      payment.price != null
                        ? `${getCurrencySymbol(payment.currency)} ${payment.price}`
                        : null,
                      payment.siteName,
                    ]
                      .filter(Boolean)
                      .join(' • ')}
                  </Typography>
                </Box>
              )}
            </>
          )}
          {!isOpen && (
            <Box sx={styles.flexRow}>
              <Typography typography="medium" color="gray.64">
                {[
                  label,
                  payment.price != null
                    ? `${getCurrencySymbol(payment.currency)} ${payment.price}`
                    : null,
                  payment.siteName,
                ]
                  .filter(Boolean)
                  .join(' • ')}
              </Typography>
            </Box>
          )}
        </>
      }
    />
  )
}

SinglePayment.propTypes = {
  payment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    datetime: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    currency: PropTypes.string,
    siteName: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  href: PropTypes.string,
  label: PropTypes.string,
  isOpen: PropTypes.bool,
  onChange: PropTypes.func,
  canRetry: PropTypes.bool,
}

export default SinglePayment
